"use strict";

module.exports = {
    Login: require('./Login'),
    ForgotPassword: require('./ForgotPassword'),
    ResetPassword: require('./ResetPassword'),
    Signup: require('./Signup'),
    Dashboard: require('./Dashboard'),
    Sidebar: require('./Sidebar'),
    Header: require('./Header'),
    Widgets: require('./Widgets'),
    Promotions: require('./Promotions'),
    Documents: require('./Documents'),
    Images: require('./Images'),
    FloorPlans: require('./FloorPlans'),
    Contact: require('./Contact'),
    PersonalizedEmail: require('./PersonalizedEmail'),
    PersonalizedBrochure: require('./PersonalizedBrochure')
};
